<div>
  <div *ngIf="objectKeys().length>0; else nothing">
    <div *ngFor="let key of objectKeys()">
      <app-event-indoor [date]="parseDate(key)" [seriesStage]="eventList[key]"></app-event-indoor>
    </div>
    <ng-template #button>
      <app-load-more-button></app-load-more-button>
    </ng-template>

  </div>
  <ng-template #nothing>
    <div *ngIf="model.loadingRef===false" >
      {{'no_results' | transloco}}
    </div>
  </ng-template>
</div>
